import { useState } from 'react';

const ContactSection = () => {
    const [formStatus, setFormStatus] = useState({
      isSubmitting: false,
      isSuccess: false,
      error: null
    });
  
    const contactInfo = [
      {
        icon: (
          <svg className="w-6 h-6 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
          </svg>
        ),
        title: "Adresse",
        content: "Quartier ZAC, Niamey. BP: 157 Niamey",
      },
      {
        icon: (
          <svg className="w-6 h-6 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
        ),
        title: "Téléphone",
        content: "+227 20 32 01 52 / +227 93 32 01 52",
        href: "tel:+22720320152"
      },
      {
        icon: (
          <svg className="w-6 h-6 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        ),
        title: "E-Mail",
        content: "info@aydees.com",
        href: "mailto:info@aydees.com"
      }
    ];
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      setFormStatus({ ...formStatus, isSubmitting: true });
      // Simuler un envoi
      setTimeout(() => {
        setFormStatus({
          isSubmitting: false,
          isSuccess: true,
          error: null
        });
        setTimeout(() => setFormStatus({
          isSubmitting: false,
          isSuccess: false,
          error: null
        }), 3000);
      }, 1000);
    };
  
    const inputStyle = {
      width:'100%', padding:'11px 14px', borderRadius:10,
      background:'rgba(255,255,255,0.9)', border:'1px solid rgba(0,0,0,0.1)',
      color:'#1e293b', fontSize:'0.9rem', outline:'none',
      boxSizing:'border-box', fontFamily:"'DM Sans',sans-serif",
      transition:'border-color .2s, box-shadow .2s',
    };
    const labelStyle = { display:'block', fontSize:'0.8rem', fontWeight:700, color:'#64748b', marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' };

    return (
      <section style={{ background:'linear-gradient(135deg,#fff7ed 0%,#ffffff 50%,#f8fafc 100%)', padding:'56px 0 52px', position:'relative', overflow:'hidden', fontFamily:"'DM Sans',sans-serif" }}>
        <div style={{ position:'absolute', inset:0, opacity:0.4, pointerEvents:'none', backgroundImage:'radial-gradient(circle,#e2e8f0 1px,transparent 1px)', backgroundSize:'28px 28px' }} />
        <div style={{ position:'absolute', top:'-10%', right:'10%', width:300, height:300, borderRadius:'50%', background:'radial-gradient(circle,rgba(232,97,26,0.15) 0%,transparent 70%)', filter:'blur(50px)', pointerEvents:'none' }} />
        <div style={{ position:'absolute', bottom:'-10%', left:'5%', width:260, height:260, borderRadius:'50%', background:'radial-gradient(circle,rgba(59,130,246,0.10) 0%,transparent 70%)', filter:'blur(50px)', pointerEvents:'none' }} />

        <div style={{ maxWidth:1160, margin:'0 auto', padding:'0 24px', position:'relative', zIndex:1 }}>
          <div style={{ textAlign:'center', marginBottom:44 }}>
            <div style={{ display:'inline-flex', alignItems:'center', gap:8, padding:'6px 18px', borderRadius:999, border:'1px solid rgba(232,97,26,0.3)', background:'rgba(232,97,26,0.08)', marginBottom:14 }}>
              <svg width="11" height="11" viewBox="0 0 24 24" fill="#E8611A"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
              <span style={{ fontSize:'0.68rem', fontWeight:700, color:'#E8611A', letterSpacing:'0.1em', textTransform:'uppercase' }}>Pour nous contacter</span>
            </div>
            <h2 style={{ fontSize:'clamp(1.4rem,3vw,2rem)', fontWeight:800, color:'#1e293b', margin:'0 0 10px', lineHeight:1.25 }}>Nous serons heureux de vous lire</h2>
            <div style={{ width:36, height:2, background:'linear-gradient(90deg,#E8611A,#16a34a)', borderRadius:4, margin:'0 auto' }} />
          </div>

          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(300px,1fr))', gap:24 }}>
            {/* Left — info */}
            <div style={{ background:'rgba(255,255,255,0.8)', backdropFilter:'blur(12px)', border:'1px solid rgba(0,0,0,0.06)', borderRadius:20, padding:'32px 28px', display:'flex', flexDirection:'column', gap:16, boxShadow:'0 4px 20px rgba(0,0,0,0.06)' }}>
              <p style={{ color:'#64748b', fontSize:'0.9rem', lineHeight:1.7, margin:'0 0 8px' }}>Nous répondrons à votre message dans les plus brefs délais.</p>
              {contactInfo.map((info, index) => (
                <a key={index} href={info.href} style={{
                  display:'flex', alignItems:'center', gap:14,
                  padding:'14px 16px', borderRadius:12,
                  background:'rgba(255,255,255,0.7)', border:'1px solid rgba(0,0,0,0.06)',
                  textDecoration:'none', transition:'background .2s, border-color .2s, box-shadow .2s',
                  cursor: info.href ? 'pointer' : 'default',
                }}
                onMouseEnter={e => { if(info.href){ e.currentTarget.style.background='rgba(255,255,255,0.95)'; e.currentTarget.style.borderColor='rgba(232,97,26,0.3)'; e.currentTarget.style.boxShadow='0 4px 16px rgba(232,97,26,0.10)'; }}}
                onMouseLeave={e => { e.currentTarget.style.background='rgba(255,255,255,0.7)'; e.currentTarget.style.borderColor='rgba(0,0,0,0.06)'; e.currentTarget.style.boxShadow='none'; }}
                >
                  <div style={{ width:42, height:42, borderRadius:10, background:'rgba(232,97,26,0.12)', border:'1px solid rgba(232,97,26,0.25)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                    {info.icon}
                  </div>
                  <div>
                    <div style={{ fontSize:'0.78rem', fontWeight:700, color:'#94a3b8', textTransform:'uppercase', letterSpacing:'0.05em' }}>{info.title}</div>
                    <div style={{ fontSize:'0.88rem', color:'#334155', fontWeight:500 }}>{info.content}</div>
                  </div>
                </a>
              ))}
            </div>

            {/* Right — form */}
            <div style={{ background:'rgba(255,255,255,0.8)', backdropFilter:'blur(12px)', border:'1px solid rgba(0,0,0,0.06)', borderRadius:20, padding:'32px 28px', boxShadow:'0 4px 20px rgba(0,0,0,0.06)' }}>
              <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:16 }}>
                <div>
                  <label style={labelStyle}>Prénom & Nom</label>
                  <input required type="text" placeholder="Votre nom complet" style={inputStyle}
                    onFocus={e => { e.target.style.borderColor='rgba(232,97,26,0.5)'; e.target.style.boxShadow='0 0 0 3px rgba(232,97,26,0.08)'; }}
                    onBlur={e => { e.target.style.borderColor='rgba(0,0,0,0.1)'; e.target.style.boxShadow='none'; }}
                  />
                </div>
                <div>
                  <label style={labelStyle}>E-Mail</label>
                  <input required type="email" placeholder="Votre adresse email" style={inputStyle}
                    onFocus={e => { e.target.style.borderColor='rgba(232,97,26,0.5)'; e.target.style.boxShadow='0 0 0 3px rgba(232,97,26,0.08)'; }}
                    onBlur={e => { e.target.style.borderColor='rgba(0,0,0,0.1)'; e.target.style.boxShadow='none'; }}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Objet</label>
                  <input required type="text" placeholder="Sujet de votre message" style={inputStyle}
                    onFocus={e => { e.target.style.borderColor='rgba(232,97,26,0.5)'; e.target.style.boxShadow='0 0 0 3px rgba(232,97,26,0.08)'; }}
                    onBlur={e => { e.target.style.borderColor='rgba(0,0,0,0.1)'; e.target.style.boxShadow='none'; }}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Message</label>
                  <textarea required rows="4" placeholder="Écrivez votre message..." style={{ ...inputStyle, resize:'none', lineHeight:1.65 }}
                    onFocus={e => { e.target.style.borderColor='rgba(232,97,26,0.5)'; e.target.style.boxShadow='0 0 0 3px rgba(232,97,26,0.08)'; }}
                    onBlur={e => { e.target.style.borderColor='rgba(0,0,0,0.1)'; e.target.style.boxShadow='none'; }}
                  />
                </div>
                <button type="submit" disabled={formStatus.isSubmitting} style={{
                  width:'100%', padding:'13px', borderRadius:10,
                  background:'#E8611A', color:'#fff', border:'none',
                  fontWeight:700, fontSize:'0.88rem', textTransform:'uppercase', letterSpacing:'0.05em',
                  cursor: formStatus.isSubmitting ? 'not-allowed' : 'pointer',
                  opacity: formStatus.isSubmitting ? 0.75 : 1,
                  display:'flex', alignItems:'center', justifyContent:'center', gap:8,
                  transition:'background .2s, transform .2s', fontFamily:"'DM Sans',sans-serif",
                }}
                onMouseEnter={e => { if(!formStatus.isSubmitting){ e.currentTarget.style.background='#d4501a'; e.currentTarget.style.transform='translateY(-2px)'; }}}
                onMouseLeave={e => { e.currentTarget.style.background='#E8611A'; e.currentTarget.style.transform='none'; }}
                >
                  {formStatus.isSubmitting ? 'Envoi en cours...' : (<>Envoyer le message <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"/></svg></>)}
                </button>
                {formStatus.isSuccess && (
                  <div style={{ padding:'10px 14px', background:'rgba(22,163,74,0.12)', border:'1px solid rgba(22,163,74,0.3)', borderRadius:10, color:'#4ade80', fontSize:'0.875rem', fontWeight:600, display:'flex', alignItems:'center', gap:8 }}>
                    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7"/></svg>
                    Message envoyé avec succès !
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>
    );
  };
  
  export default ContactSection;